import { lazy } from 'react'

export const AddPreconfig = lazy(() => import('./AddPreconfig'))
export const AddProduct = lazy(() => import('./AddProduct'))
export const AddProductV2 = lazy(() => import('./AddProductV2'))
export const BudgetQuotationUsa = lazy(() => import('./BudgetQuotationUsa'))
export const CollectionList = lazy(() => import('./CollectionList'))
export const CollectionDecisionTreeView = lazy(() => import('./CollectionDecisionTreeView'))
export const GenerateBudget = lazy(() => import('./GenerateBudget'))
export const Export3DList = lazy(() => import('./Export3DList'))
export const NotAllowedView = lazy(() => import('./NotAllowed'))
export const NotFoundView = lazy(() => import('./NotFound'))
export const OrderList = lazy(() => import('./OrderList'))
export const OrderDetails = lazy(() => import('./OrderDetails'))
export const PasswordReset = lazy(() => import('./PasswordReset'))
export const PlaceOrder = lazy(() => import('./PlaceOrder'))
export const PlusminusNodrawingConfigurator = lazy(() => import('./PlusminusNodrawingConfigurator'))
export const PlusminusDrawingConfiguratorIframeContent = lazy(() => import('./PlusminusDrawingConfiguratorIframeContent'))
export const Export3dContainer = lazy(() => import('./Export3dContainer'))
export const Export3dIframeContent = lazy(() => import('./Export3dIframeContent'))
export const Export3dPlayerIframeContent = lazy(() => import('./Export3dPlayerIframeContent'))
export const PlusminusDrawingConfiguratorContainer = lazy(() => import('./PlusminusDrawingConfiguratorContainer'))
export const PlusminusDrawingConfiguratorWithHash = lazy(() => import('./PlusminusDrawingConfiguratorWithHash'))
export const Export3dConfigurator = lazy(() => import('./Export3dConfigurator'))
export const PreconfigListView = lazy(() => import('./PreconfigList'))
export const ProductExpressConfiguratorView = lazy(() => import('./ProductExpressConfigurator'))
export const ProjectDownloads = lazy(() => import('./ProjectDownloads'))
export const ProjectTechnicalDownloads = lazy(() => import('./ProjectTechnicalDownloads'))
export const ProductCreaConfiguratorView = lazy(() => import('./ProductCreaConfigurator'))
export const ProjectListView = lazy(() => import('./ProjectList'))
export const ProjectPageView = lazy(() => import('./ProjectPage'))
export const RequestBudget = lazy(() => import('./RequestBudget'))
export const RequestBudgetUsa = lazy(() => import('./RequestBudgetUsa'))
export const ProjectRegistrationUsa = lazy(() => import('./ProjectRegistrationUsa'))
export const Sandbox = lazy(() => import('./Sandbox'))
export const SticksNodrawingConfigurator = lazy(() => import('./SticksNodrawingConfigurator'))
export const SticksDrawingConfigurator = lazy(() => import('./SticksDrawingConfigurator'))
export const UserProfile = lazy(() => import('./UserProfile'))
export const UsersManagement = lazy(() => import('./UsersManagement'))
export const Invoices = lazy(() => import('./Invoices'))
export const NewRegister = lazy(() => import('./NewRegister'))

export const Compositor = lazy(() => import('./Compositor'))
export const CompositorV2 = lazy(() => import('./CompositorV2'))
export const MiniCompositor = lazy(() => import('./PreconfigListToolkit'))
export const GeneratePreviews = lazy(() => import('./GeneratePreviews'))
export const GeneratePdf = lazy(() => import('./GeneratePdf'))
export const TechnicalInformation = lazy(() => import('./TechnicalInformation'))
export const Studio = lazy(() => import('./Studio'))

export const ProductSheetView = lazy(() => import('./ProductSheetView'))
export const RegularProductConfiguratorCreateView = lazy(() => import('./RegularProductConfigurator/RegularProductConfiguratorCreateView'))
export const RegularProductConfiguratorEditView = lazy(() => import('./RegularProductConfigurator/RegularProductConfiguratorEditView'))
export const BundleListConfiguratorCreateView = lazy(() => import('./BundleListConfigurator/BundleListConfiguratorCreateView'))
export const BundleListConfiguratorEditView = lazy(() => import('./BundleListConfigurator/BundleListConfiguratorEditView'))
export const ToolkitListConfiguratorCreateView = lazy(() => import('./ToolkitListConfigurator/ToolkitListConfiguratorCreateView'))
export const ToolkitListConfiguratorEditView = lazy(() => import('./ToolkitListConfigurator/ToolkitListConfiguratorEditView'))
export const ToolkitListConfiguratorPreconfigView = lazy(() => import('./ToolkitListConfigurator/ToolkitListConfiguratorPreconfigView'))
export const PiecesListView = lazy(() => import('./PiecesList/PiecesListView'))
export const Compositor2DView = lazy(() => import('./Compositor2D/Compositor2DView'))
export const ProductInfoAndDownloadsView = lazy(() => import('./ProductInfoAndDownloadsView'))
export const ProductAdmin = lazy(() => import('./ProductAdmin'))
export const ProductAdminCompositor = lazy(() => import('./ProductAdmin/Compose'))
export const ProductAdminEditRule = lazy(() => import('./ProductAdmin/EditRule'))
export const ProductAdminPreview = lazy(() => import('./Preview/Compose'))
export const ValidationView = lazy(() => import("./Validation/Validation.view"))
export const ServiceDownload = lazy(() => import('./ServicesDownload'))

export const CollectionFilter = lazy(() => import('./CollectionFilter/CollectionFilterView'))